import { Button, Card, Grid, makeStyles } from "@material-ui/core";
import { useFormikContext } from "formik";

import { useHistory } from "react-router-dom";
import GovButtonGroup from "../../../../components/GovButtonGroup";
import GovGrButton from "../../../../components/GovGrButton";
import {
  PRIMARY,
  SECONDARY,
  LINK,
} from "../../../../components/GovGrButton/buttonConstants";
import { INITIAL_SUBMIT, TEMPORARILY_SAVED } from "../../../../constants";
import useLocale from "../../../../hooks/useLocale";

const Controls = ({ disabledSubmitButton }) => {
  const { submitForm, setFieldValue } = useFormikContext();
  const classes = useStyles();
  const { t } = useLocale();
  const history = useHistory();

  return (
    <Card
      style={{ border: "1px solid rgb(204,204,204)" }}
      className={classes.controlsContainer}
    >
      <Grid
        alignItems="center"
        container
        justifyContent="space-between"
        className={classes.buttonContainer}
        spacing={6}
      >
        <Grid item>
          <GovGrButton
            variant={LINK}
            buttonText={t("Cancel application")}
            hasImage={false}
            onClick={() => {
              history.push("/");
            }}
          />
        </Grid>
        <Grid
          display={"inline-block"}
          item
          xs={7}
          container
          wrap="nowrap"
          justifyContent="flex-end"
          spacing={0}
        >
          <Grid item>
            <GovButtonGroup>
              <GovGrButton
                variant={SECONDARY}
                buttonText={t("Temporary save")}
                hasImage={false}
                onClick={async () => {
                  await setFieldValue("status", TEMPORARILY_SAVED);
                  submitForm();
                }}
              />

              <GovGrButton
                variant={PRIMARY}
                buttonText={t("Submit")}
                hasImage={false}
                disabled={disabledSubmitButton}
                onClick={async () => {
                  await setFieldValue("status", INITIAL_SUBMIT);
                  submitForm();
                }}
              />
            </GovButtonGroup>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

const useStyles = makeStyles(() => ({
  card: {
    display: "flex",
    flexDirection: "column",
    minWidth: 500,
    maxWidth: "30vw",
    marginBottom: "1.2rem",
    marginRight: "1.2rem",
  },
  controlsContainer: {
    margin: "10px 0",
  },
  buttonContainer: {
    padding: "20px",
  },
  cancelButton: {
    color: "red",
  },
  submitButton: {
    padding: "10px 80px",
    marginLeft: "25px",
  },
  infoTypography: {
    margin: "1rem 0",
  },
  cardsSpace: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    height: 400,
    alignItems: "center",
  },
  contentCard: {
    display: "inline-flex",
  },
  insideContentMargin: {
    marginRight: "2rem",
  },
}));

export default Controls;
